import Link from 'next/link';

type Props = {
  serviceTitle: string;
  subServiceName?: string;
  subServiceHref?: string;
  locale: string;
  children?: React.ReactNode;
  className?: string;
};

export default function ServiceLink({
  serviceTitle,
  subServiceName = '',
  subServiceHref,
  locale,
  children,
  className = 'text-sm text-[#4a3b5f] hover:text-[#FBD915] transition-colors duration-200',
}: Props) {
  const serviceSlug = encodeURIComponent(serviceTitle.toLowerCase()
    .replace(/&/g, '')
    .replace(/\s+/g, '-'));
    

const href = subServiceName && subServiceHref
    ? `/${locale}/services/${serviceSlug}/${subServiceHref}`
    : `/${locale}/services/${serviceSlug}`;

  return (
    <Link href={href} className={className}>
      {children || subServiceName || serviceTitle}
    </Link>
  );
}
